
export const SET_USER = 'SET_USER'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_IS_PASSWORD_RESETED = 'SET_IS_PASSWORD_RESETED'
export const SET_IS_DELETED_PROFILE = 'SET_IS_DELETED_PROFILE'
